import React, { Context, createContext, useContext } from "react";
import { ClinicDao } from "fe-common/graphql/dao";

const DaoContext: Context<ClinicDao> = createContext<ClinicDao>(null);
export const useClinicContext = () => useContext(DaoContext);

export const ClinicDaoProvider = ({
  value,
  children,
}: {
  value: ClinicDao;
  children?: any;
}) => <DaoContext.Provider value={value}>{children}</DaoContext.Provider>;
